import styled, { css } from 'styled-components';
import { FlagOutlineIc, CreateIc } from '@dsch/dd-icons';
import { adWriteApi } from '../../../../../api/adWriteApi';
import { fireToast } from '../../../../../helpers/Toasts';
import { useAdDetailsContext } from '../../../../../contexts/AdDetailsContext';

import { Link } from '../../../../../components/Toolkit/Button/Link';
import { formatAuthorizationHeader } from '../../../../../helpers/auth';
import { useAuthOptions } from '../../../../../hooks/useAuthOptions';
import { LinkButton } from '../../../../../components/Toolkit/Button/LinkButton';
import { PAGE } from '../../../../../helpers/pages';
import { RevealReportAdProps } from './RevealReportAd.typed';
import { logger } from '@dist-marketplace-frontend/services';

const iconCSS = css`
  margin-right: ${({ theme }) => theme.spacing.S4};
`;

const CreateIcon = styled(CreateIc)`
  ${iconCSS}
`;

const FlagIcon = styled(FlagOutlineIc)`
  ${iconCSS}
`;

const ManageMyAdLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const ReportAdLinkButton = styled(LinkButton)`
  display: flex;
  align-items: center;
`;

/**
 * @warning Used by Pingdom to check if the site is up.
 * If you change this string, please inform SRE.
 */

const REPORT_AD_TEXT = 'Report Ad';

const RevealReportAd = (props: RevealReportAdProps) => {
  const { isViewingOwnAd = false, editAdHREF } = props;

  const { setIsReportAdModalOpen, setCategories, categories } =
    useAdDetailsContext();
  const { accessToken } = useAuthOptions();

  async function handleReveal() {
    try {
      if (!categories || categories.length === 0) {
        const { data } = await adWriteApi.getReportAdCategories(
          formatAuthorizationHeader(accessToken),
        );
        setCategories(data);
      }
      setIsReportAdModalOpen(true);
    } catch (error) {
      logger.error({
        message: 'Error getting report ad categories',
        error,
        customData: {
          pageName: PAGE.AD_DETAILS,
          functionName: 'handleReveal',
        },
      });
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later',
      });
      return false;
    }
  }

  return (
    <>
      {!isViewingOwnAd ? (
        <ReportAdLinkButton
          ofType="TERTIARY"
          fontSize="M14"
          onClick={handleReveal}
        >
          <FlagIcon height="16" width="16" />
          <span>{REPORT_AD_TEXT}</span>
        </ReportAdLinkButton>
      ) : (
        <ManageMyAdLink ofType="TERTIARY" href={editAdHREF}>
          <CreateIcon height="16" width="16" />
          <span>Manage my ad</span>
        </ManageMyAdLink>
      )}
    </>
  );
};

export { RevealReportAd };
